module.exports = __webpack_public_path__ + "img/dedova.d06511ad.png";